"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.data = void 0;
Object.defineProperty(exports, "events", {
  enumerable: true,
  get: function () {
    return _events.default;
  }
});
var _events = _interopRequireDefault(require("./events"));
var _data = _interopRequireDefault(require("./data"));
var _render = _interopRequireDefault(require("./render"));
var _eventToApi = _interopRequireDefault(require("./event-to-api"));
var _shopperData = _interopRequireDefault(require("./shopper-data"));
var _svgosm = require("@ux/icon/svgosm.js");
const target = typeof document !== 'undefined' ? window : {};
const data = new _data.default();
exports.data = data;
const eldorado = {};
target.ux = target.ux || {};
target.ux.eldorado = target.ux.eldorado || eldorado;

//
// Allow external JS to listen to events emitted from the manifests and prepare
// data object.
//
target.ux.eldorado.events = eldorado.events || _events.default;
target.ux.eldorado.data = eldorado.data || data;

//
// Setup listeners to expose mounted instances.
// REMARK(jkeslin): Keeping eldorado references for back-compat, but docs should stop referencing it
//
target.ux.header = target.ux.eldorado.header = (0, _eventToApi.default)('mount:header');
target.ux.footer = target.ux.eldorado.footer = (0, _eventToApi.default)('mount:footer');

// To keep backwards compatibility with Eldorado
if (typeof target.jQuery === 'function') {
  target.ux.jQuery = target.ux.eldorado.jQuery = target.jQuery;
}

/**
 * If jQuery is present on the page, run the specified callback when jQuery is ready.
 * Otherwise, run the callback synchronously
 *
 * @param {Function} cb The callback to run
 * @api private
 */
target.ux._runOnJQueryReady = function runOnJQueryReady(cb) {
  if (target.ux.jQuery) {
    target.ux.jQuery(document).ready(cb);
  } else {
    cb(); // eslint-disable-line callback-return
  }
};

// When the header mounts, make all subsequent calls to ux.eldorado.ready synchronous
target.ux.header(function uxEldoradoReadyOnMountHeader() {
  target.ux.eldorado.ready = function uxEldoradoReadyImmediate(cb) {
    target.ux._runOnJQueryReady(cb);
  };
});

/**
 * Register the specified callback to run when UXCore1 is loaded.
 *
 * Note: If UXCore1 is never loaded (e.g. if the page is using UXCore2), the callback will never run.
 *
 * @param {Function} cb The callback to run
 * @api public
 */
target.ux.ready = function uxReady(cb) {
  target.ux.fns = target.ux.fns || [];
  target.ux.fns.push(cb);
};

/**
 * Set the root element to use for Icon's SVGOSM.
 *
 * @param {HTMLElement} root HTML element.
 * @public
 */
target.ux.setSVGRoot = function setSVGRoot(root) {
  if (!_svgosm.svgosm) return;
  _svgosm.svgosm.mount(root);
};

/**
 * Register the specified callback to run when the header is mounted.
 *
 * @param {Function} cb The callback to run
 * @api public
 */
target.ux.eldorado.ready = function uxEldoradoReady(cb) {
  target.ux.header(function headerReady() {
    target.ux._runOnJQueryReady(cb);
  });
};

// Transfer over all the callbacks that queued up before this script loaded
if (Array.isArray(target.ux.eldorado.readyFns)) {
  target.ux.eldorado.readyFns.forEach(function (fn) {
    target.ux.eldorado.ready(fn);
  });
  target.ux.eldorado.readyFns = null;
}

// Set up shopperData API and handle pre-queued callbacks
if (!target.ux.eldorado._shopperDataLoader) {
  // Create a new ShopperDataLoader
  target.ux.eldorado._shopperDataLoader = _shopperData.default;

  // Attach it to the existing `shopperData` function
  target.ux.shopperData = target.ux.eldorado.shopperData = _shopperData.default.shopperData.bind(_shopperData.default);

  // Run all pre-queued callbacks in order
  if (target.ux.eldorado._shopperDataFns) {
    target.ux.eldorado._shopperDataFns.forEach(fn => {
      target.ux.shopperData(fn);
    });
  }
}

//
// Expose our render method for public consumption so
//
target.ux.render = _render.default;
target.ux.mounted = (0, _eventToApi.default)('mount');